module.exports = __webpack_public_path__ + "img/disc_golf_header.7a1588fa.png";